import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import "./DateRangePicker.scss"

export default {
	components: { DatePicker },
	props: {
		endDate: {
			type: String,
		},
		startDate: {
			type: String,
		},
	},

	data() {
		return {
			rangeDate: [
				this.startDate ? new Date(this.startDate) : '',
				this.endDate ? new Date(this.endDate) : '',
			],
		};
	},

	computed: {
		popupClass() {
			return "popupClass"
		}
	},

	methods: {
		selectThisMonth(emit) {
			const end = new Date();
			const start = new Date();

			console.log('start:', start.getTime(), start.getDate());
			start.setTime(
				start.getTime() - (start.getDate() - 1) * 24 * 3600 * 1000
			);
			const date = [start, end];
			emit(date);
			//   console.log("time 3:", this.value3);
		},
		selectToday(emit) {
			const end = new Date();
			const start = new Date();
			const date = [start, end];
			emit(date);
		},
		selectYesterday(emit) {
			const end = new Date();
			const start = new Date();
			start.setTime(start.getTime() - 24 * 3600 * 1000);
			end.setTime(end.getTime() - 24 * 3600 * 1000);
			const date = [start, end];
			emit(date);
		},
		selectPreviousSevenDay(emit) {
			const end = new Date();
			const start = new Date();
			const date = this.numberPreviousDay(start, end, 7);
			emit(date);
		},
		selectPreviousThirtyDay(emit) {
			const end = new Date();
			const start = new Date();
			const date = this.numberPreviousDay(start, end, 30);
			emit(date);
		},
		numberPreviousDay(start, end, previousNumber) {
			start.setTime(
				start.getTime() - previousNumber * 24 * 3600 * 1000
			);
			const date = [start, end];
			return date;
		},

		// selectLastMonth(emit) {
		//   const end = new Date();
		//   const start = new Date();
		//   console.log("start:", start.getTime(), start.getDate());
		//   start.setTime(
		//     start.getTime() -
		//       start.getDate() * 24 * 3600 * 1000 -
		//       30 * 24 * 3600 * 1000
		//   );
		//   end.setTime(end.getTime() - end.getDate() * 24 * 3600 * 1000);
		//   const date = [start, end];
		//   emit(date);
		//   //   console.log("time 3:", this.value3);
		// },
	},
};
